import { render, staticRenderFns } from "./CXCart.vue?vue&type=template&id=57febf30"
import script from "./CXCart.vue?vue&type=script&lang=js"
export * from "./CXCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports